module.exports = __webpack_public_path__ + "static/media/player.b1b34c32.svg";